var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"warn"},[(_vm.showIcon)?_c('div',{staticClass:"warn-icon"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"warn-text"},_vm._l((_vm.textArr),function(item){return _c('div',[_vm._v(_vm._s(item))])})),_vm._v(" "),_c('div',{staticClass:"warn-button",on:{"click":_vm.confirm}},[_vm._v("确定")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5860edfa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account-dialog/account-dialog.vue
// module id = null
// module chunks = 